import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { takeUntil } from 'rxjs/operators';

import {
  BaseComponent,
  BaseEditFormModalComponent,
  FormsValidators,
  Guid,
  Product,
  ProductForSalesOrderLine,
  ProductService,
  PurchaseOrderLineService,
  TmsFormlyService,
} from 'tms-lib';
import { PurchaseOrderLineRequirementService } from '../../../services';

@Component({
  selector: 'app-purchase-order-line-requirement-modal',
  templateUrl: './purchase-order-line-requirement-modal.component.html',
  styleUrl: './purchase-order-line-requirement-modal.component.scss',
})
export class PurchaseOrderLineRequirementModalComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormModalComponent) form: BaseEditFormModalComponent;

  @Input() id: string;
  @Input() purchaseOrderLineId: string;

  fields: FormlyFieldConfig[];

  constructor(
    public purchaseOrderLineRequirementService: PurchaseOrderLineRequirementService,
    private purchaseOrderLineService: PurchaseOrderLineService,
    private productService: ProductService,
    private formlyService: TmsFormlyService,
  ) {
    super();
  }

  ngOnInit() {
    this.getFields();
  }

  private getFields() {
    this.fields = [
      ...this.formlyService.productSearch(
        'productSearch',
        'productId',
        (model: Product) => this.changeProduct(model),
        () => this.clearProduct(),
      ),
      this.formlyService.text('productKey', $localize`Product`, undefined, { readonly: true, required: true }),
      this.formlyService.text('productDescription', $localize`Description`, undefined, {
        readonly: true,
        required: true,
      }),
      this.formlyService.text('productTypeDescription', $localize`Product Type`, undefined, {
        readonly: true,
        required: true,
      }),
      this.formlyService.number(
        'quantity',
        'Quantity',
        undefined,
        {
          required: true,
        },
        undefined,
        undefined,
        [FormsValidators.greaterThan(0)],
      ),
    ];
  }

  saved() {
    this.purchaseOrderLineService.refreshDetails.next();
  }

  private changeProduct(model: Product) {
    this.productService
      .getProductForSalesOrder(model.id, Guid.empty, '', '')
      .pipe(takeUntil(this.destroy$))
      .subscribe((product: ProductForSalesOrderLine) => this.form.updateModel(product));
  }

  private clearProduct() {
    this.form.updateModel({
      productId: undefined,
      productKey: undefined,
      productDescription: undefined,
      productTypeDescription: undefined,
    });
  }
}
